export var ETopicAuthenticationAction;
(function (ETopicAuthenticationAction) {
    ETopicAuthenticationAction["SIGNIN"] = "authentication.signin";
    ETopicAuthenticationAction["SIGNOUT"] = "authentication.signout";
    ETopicAuthenticationAction["RENEWED_TOKEN"] = "authentication.renewed-token";
    ETopicAuthenticationAction["ASK_TOKEN"] = "authentication.ask-token";
})(ETopicAuthenticationAction || (ETopicAuthenticationAction = {}));
